var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2"},[_c('b-btn',{staticClass:"pl-0",attrs:{"variant":"link","size":"lg"},on:{"click":_vm.backToDashboard}},[_c('font-awesome-icon',{attrs:{"size":"lg","icon":"fa-light fa-chevron-left"}}),_vm._v(" Dashboard ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }